import { registerEntityEndpoint as e } from "@editor/ui-utils";
var t = e("linkout-teaser"), { getEntity: n, listEntities: r, putEntity: i, postEntity: a, deleteEntity: o } = t, s = async (e) => n(e), c = async (e) => a(e), l = async (e) => {
	let { _id: t, ...n } = e;
	return i(t, n);
}, u = async (e) => o(e), d = () => ({
	brand: "chip",
	type: "internal",
	internalName: "",
	isDeleted: !1,
	content: {
		imageUuid: "",
		title: "",
		kicker: void 0,
		link: "",
		leadText: void 0,
		hasAdvertisementMark: !1,
		hasVideo: !1,
		linkAttributes: {
			nofollow: !0,
			openInNewTab: !0
		}
	}
});
//#endregion
export { c as a, s as i, u as n, l as o, d as r, t };

//# sourceMappingURL=linkout-teaser.service-B5YdKRDR.js.map